import { httpPost } from "../../services/api";

export const sdkCheckLoyaltyProviders = async ({
  providerId,
  identifier,
  identifierType,
  publicApiKey,
}: {
  publicApiKey: string;
  providerId: string;
  identifier: string;
  identifierType: LoyaltyProvider["identifier_type"];
}) => {
  const response = await httpPost<{
    data: {
      eligible: boolean;
    };
  }>(
    "loyalty/eligibility/",
    { provider_id: providerId, identifier, identifier_type: identifierType },
    undefined,
    {
      "x-public-key": publicApiKey,
    }
  );

  return {
    eligible: response.data.eligible,
  };
};
